module.exports = __webpack_public_path__ + "img/dashboard-team.e5dccf4d.svg";